import React, { useEffect, useState } from "react";
import HeaderHome from "../headers/headerHome";
import * as API from "../services/API";
import GalerieViewer from "../components/GalerieViewer";
import "../css/Galerie.css";
import Footer from "../components/Footer";

function Galerie(){
	const [GalerieList, setGalerieList] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const [GalerieCategoriesList, setGalerieCategoriesList] = useState([]);


 // Fonction pour ouvrir la modal avec l'image sélectionnée
 const openImageModal = (image) => {
    setSelectedImage(image);
  };
  // Fonction pour fermer la modal
  const closeModal = () => {
    setSelectedImage(null);
  };
	useEffect(() => {
		API.getPublicGalerieRequest(
			(response)=>{
				setGalerieList(response.data.data);
			},
			()=>{
			}
			)
		API.getGalerieCategoriesRequest(
			(response)=>{
				setGalerieCategoriesList(response.data);
			},
			()=>{}
		);
		},
		[]
		);
	const imagesByCategory = React.useMemo(() => {
			const map = {};

			[...GalerieCategoriesList]
			.sort((a, b) => (a.order || 0) - (b.order || 0))
			.forEach(cat => {
				map[cat._id] = {
					name: cat.name,
					images: []
				};
			});

			map["uncategorized"] = {
				name: "A découvrir",
				images: []
			};

			GalerieList.forEach(img => {
				const catId = img.categoryId;

				if (catId && map[catId]) {
					map[catId].images.push(img);
				} else {
					map["uncategorized"].images.push(img);
				}
			});

			return Object.values(map).filter(g => g.images.length > 0);

	}, [GalerieList, GalerieCategoriesList]);

	return (
		<>
            <div>
			    <HeaderHome /> 
					<h2 className="text-center m-5">Galerie</h2>
					<div className="container">
					{imagesByCategory.length === 0 ? (
					<div className="text-center py-5">
					<h4 className="mb-3">La galerie arrive bientôt ✨</h4>
					<p className="text-muted">
						Nous préparons de belles photos à partager avec vous.
						Revenez prochainement pour les découvrir !
					</p>
					</div>
				) : (
					imagesByCategory.map((group, i) => (
					<div key={i} className="mb-5">

						<h3
						className="mb-4 pb-2"
						style={{
							borderBottom: "1px solid #e5e5e5",
							fontWeight: 600
						}}
						>
						{group.name}
						</h3>

						<div className="row g-4">
						{group.images.map((image, index) => (
							<div
							key={index}
							className="col-12 col-sm-6 col-md-4 col-lg-3"
							onClick={() => openImageModal(image)}
							style={{ cursor: "pointer" }}
							>
							<div className="gallery-card">
								<img
								src={image.image}
								alt=""
								className="img-fluid"
								/>
							</div>
							</div>
						))}
						</div>

					</div>
					))
				)}
				</div>
				<Footer/>
            </div>
			
            <GalerieViewer
                groups={imagesByCategory}
                selectedImage={selectedImage}
                onSelect={setSelectedImage}
                onClose={closeModal}
            />


      
		</>
	);
}


export default Galerie;